import React from "react";
import { useNavigate } from "react-router-dom";

const SubscriptionAlert = ({ data }) => {
  const navigate = useNavigate();

  const submitHandler = () => {
    navigate(`../myspace/subscription`, {
      state: { buyPlan: "Premium" },
    });
  };
  return (
    <div className="subscription-modal">
      <div className="card-body modal-body">
        <p>{data?.content}</p>
      </div>
      {data?.name === "Basic" && (
        <div className="modal-footer">
          <button className="btn btn-primary mt-4" onClick={submitHandler}>
            Subscribe
          </button>
        </div>
      )}
    </div>
  );
};

export default SubscriptionAlert;
